import { useAppSelector } from '@/store/hooks';
import {
  selectAccessToken,
  selectAuthToken,
  groupNameSelector,
  selectInspectorDisplayName,
  selectUserId,
  selectUserEmailSelector,
  positionNamesSelector,
} from '@/store/auth/auth.selector';
import { ContactSupport, Dialog, DialogContent } from '@zawarski/eti-ui';

interface ContactSupportModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ContactSupportModal({ open, onOpenChange }: ContactSupportModalProps) {
  const accessToken = useAppSelector(selectAccessToken);
  const cognitoToken = useAppSelector(selectAuthToken);
  const groupName = useAppSelector(groupNameSelector);
  const userId = useAppSelector(selectUserId);
  const name = useAppSelector(selectInspectorDisplayName);
  const email = useAppSelector(selectUserEmailSelector);
  const positions = useAppSelector(positionNamesSelector);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <div className='flex w-full'>
          <ContactSupport
            cognitoToken={cognitoToken ?? ''}
            email={email ?? ''}
            fileStoreToken={accessToken ?? ''}
            fileStoreUserId={userId}
            group={groupName}
            name={name}
            positions={positions}
            onSuccess={() => onOpenChange(false)}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
